import { Box, Flex, SpacingStack, StyleSystemProps, styled, ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { PRODUCT_GRID_BREAKPOINTS } from '../../../../Catalog.constants';

export const StyledProductGridHighlightsWrapper = styled(Box)``;
const productHighlightsWrapperStyles: StyleSystemProps = {
  gridColumn: '1 / -1', // claim the whole row
  _before: {
    display: 'none',
  },
  _after: {
    display: 'none',
  },
  paddingY: {
    _: 5,
    [PRODUCT_GRID_BREAKPOINTS[1]]: 10,
  },
  paddingX: 7,
  marginY: 7,
  marginX: {
    _: -3,
    [PRODUCT_GRID_BREAKPOINTS[1]]: -7,
  },
  backgroundColor: 'mono1',
};

export const StyledProductGridHighlightsItems = styled(Box)``;
const productHighlightsItemsStyles: StyleSystemProps = {
  display: {
    _: 'flex',
    [PRODUCT_GRID_BREAKPOINTS[1]]: 'grid',
  },
  marginRight: {
    [PRODUCT_GRID_BREAKPOINTS[1]]: -7,
  },
  flexDirection: 'column',
  gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
  columnGap: 7,
};

export const StyledProductGridHighlightsItem = styled(Flex)``;
const productHighlightsItemStyles: StyleSystemProps = {
  flex: '1 1 auto',
  columnGap: 5,
  paddingRight: {
    [PRODUCT_GRID_BREAKPOINTS[1]]: 7,
  },
  paddingY: {
    _: 6,
    [PRODUCT_GRID_BREAKPOINTS[1]]: 0,
  },
  borderRight: {
    _: 'none',
    [PRODUCT_GRID_BREAKPOINTS[1]]: '1px solid',
  },
  borderBottom: {
    _: '1px solid',
    [PRODUCT_GRID_BREAKPOINTS[1]]: 'none',
  },
  borderColor: {
    _: 'mono3',
    [PRODUCT_GRID_BREAKPOINTS[1]]: 'mono3',
  },
  _first: {
    paddingTop: 0,
  },
  _last: {
    paddingBottom: 0,
    borderRight: 'none',
    borderBottom: 'none',
  },
  flexDirection: 'column',
};

export const StyledProductGridHighlightsItemLink = styled(Flex)``;
const productHighlightsItemLinkStyles: StyleSystemProps = {
  columnGap: 5,
  rowGap: 5,
  paddingY: 3,
  flexDirection: {
    _: 'column',
    [PRODUCT_GRID_BREAKPOINTS[2]]: 'row',
  },
};

export const StyledProductGridHighlightsItemInfo = styled(SpacingStack)``;
const productHighlightsItemInfoStyles: StyleSystemProps = {
  flex: {
    _: 'none',
    [PRODUCT_GRID_BREAKPOINTS[2]]: '1 1 50%',
  },
  justifyContent: {
    [PRODUCT_GRID_BREAKPOINTS[2]]: 'center',
  },
  minHeight: {
    _: 'auto',
    [PRODUCT_GRID_BREAKPOINTS[1]]: pxToRem(120),
    [PRODUCT_GRID_BREAKPOINTS[2]]: 'auto',
  },
};

export const StyledProductGridHighlightsItemImageWrapper = styled(Flex)`
  aspect-ratio: 1/1;
`;
const productHighlightsItemImageWrapperStyles: StyleSystemProps = {
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 2,
  zIndex: 1,
  backgroundColor: 'mono1',
  flex: {
    _: 'none',
    [PRODUCT_GRID_BREAKPOINTS[2]]: '1 1 50%',
  },
  maxWidth: {
    _: '100%',
    [PRODUCT_GRID_BREAKPOINTS[2]]: pxToRem(175),
  },
};

export const StyledProductGridHighlightsItemButton = styled(ButtonV2)``;

export const FlexWrapper = styled(Flex)``;

export const styles = {
  productHighlightsWrapper: productHighlightsWrapperStyles,
  productHighlightsItems: productHighlightsItemsStyles,
  productHighlightsItem: productHighlightsItemStyles,
  productHighlightsItemLink: productHighlightsItemLinkStyles,
  productHighlightsItemInfo: productHighlightsItemInfoStyles,
  productHighlightsItemImageWrapper: productHighlightsItemImageWrapperStyles,
};
